/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CheckoutOrderingAddressStep_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CheckoutOrderingSteps_viewer$ref: FragmentReference;
declare export opaque type CheckoutOrderingSteps_viewer$fragmentType: CheckoutOrderingSteps_viewer$ref;
export type CheckoutOrderingSteps_viewer = {|
  +$fragmentRefs: CheckoutOrderingAddressStep_viewer$ref,
  +$refType: CheckoutOrderingSteps_viewer$ref,
|};
export type CheckoutOrderingSteps_viewer$data = CheckoutOrderingSteps_viewer;
export type CheckoutOrderingSteps_viewer$key = {
  +$data?: CheckoutOrderingSteps_viewer$data,
  +$fragmentRefs: CheckoutOrderingSteps_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CheckoutOrderingSteps_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CheckoutOrderingAddressStep_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a17c7e9e4def549670871e83d6c5b36e';

module.exports = node;
